module.exports = __webpack_public_path__ + "img/p6.4d76369b.webp";